var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-sidebar',{attrs:{"id":"sidebar-canvas","visible":_vm.showCanvasModal,"title":"","left":"","bg-variant":"transparent"}},[_c('div',{staticClass:"px-3 py-2",staticStyle:{"background-color":"transparent"}},[_c('b-img',{staticStyle:{"width":"80%","heiaght":"80%"},attrs:{"src":"resources/images/canvas/arteriesandveins.gif","fluid":""}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }